<template>
  <div class="table-page-wrapper">

    <div v-show="searchStatus" class="search-wrapper">
      <search-channel-app-select v-model="tableParams.appId" />
      <el-select v-model="tableParams.isDate" clearable filterable  placeholder="显示类型"
        style="margin-right: 15px;width: 110px">
        <el-option label="按日期" :value="1" />
        <el-option label="正常显示" :value="0" />
      </el-select>
      <base-date-picker @changeDate="changeDate" style="margin-right: 15px;" />
      <el-button @click="toQuery" type="primary" >搜索</el-button>
    </div>

    <div class="table-wrapper">
      <table-column @search="searchColumn" @refresh="toQuery" @change="changeColumn" :column="columns"
        style="padding-bottom: 10px;">
        <el-button @click="downExcel('/app/channel/report/csv', '应用报表', tableParams)" type="warning" size="small">下载
        </el-button>
      </table-column>

      <el-table v-loading="tableLoading" :data="tableData" height="80vh" :header-cell-style="{ background: '#fafafa' }"
        :summary-method="tableSummary" show-summary highlight-current-row size="small" class="js-table"
        style="width: 100%">
        <el-table-column v-if="tableParams.isDate" prop="reportTime" sortable label="日期" align="center" />
        <el-table-column v-for="(v, i) in checkColumns" :prop="v.field" :label="v.title" :width="v.width"
          :sortable="['showSmt', 'ecpm', 'clkSmt', 'clickRate', 'income'].indexOf(v.field) > -1" :min-width="v.minWidth"
          :key="i" align="center">
          <template v-slot="scope">
            <el-tag v-if="v.field === 'clickRate'" type="info">{{ scope.row[v.field] }}%</el-tag>
            <span v-else>{{ scope.row[v.field] }}</span>
          </template>
        </el-table-column>
      </el-table>

      <el-pagination @size-change="sizeChange" @current-change="currentChange" :total="pagination.total"
        :pager-count="6" :current-page="pagination.pageNum" :page-size="pagination.pageSize" :page-sizes="[10, 30, 60]"
        background layout="total,sizes,prev,pager,next" style="margin-top: 40px;" />
    </div>
  </div>
</template>

<script>
import BaseDatePicker from '@/components/BaseDatePicker'
import TableColumn from '@/components/TableColumn'

import initTableMixin from '@/mixins/initTable'
import downExcelMixin from '@/mixins/downExcel'
import SearchChannelAppSelect from '@/components/SearchChannelAppSelect'

export default {
  name: 'reportChannelApp',
  components: {
    BaseDatePicker,
    TableColumn,
    SearchChannelAppSelect
  },
  mixins: [initTableMixin, downExcelMixin],
  data() {
    return {
      columns: [
        { field: 'appId', title: '应用ID' },
        { field: 'appName', title: '应用名称' },
        { field: 'showSmt', title: '展示数' },
        { field: 'ecpm', title: 'eCPM' },
        { field: 'clkSmt', title: '点击数' },
        { field: 'clickRate', title: '点击率' },
        { field: 'income', title: '预计收入' }
      ]
    }
  },
  created() {
    this.tableParams.isDate = 1
  },
  mounted() {
    this.$nextTick(() => {
      this.init()
    })
  },
  methods: {
    beforeInit() {
      this.tableUrl = '/app/channel/report'
      this.tableParams.pageNum = this.pagination.pageNum
      this.tableParams.pageSize = this.pagination.pageSize
      return true
    },
    changeDate(date) {
      this.tableParams.startTime = date.startTime
      this.tableParams.endTime = date.endTime
    },
    sizeChange(e) {
      this.pagination.pageSize = e
      this.tableParams.pageSize = e
      this.init()
    },
    currentChange(e) {
      this.pagination.pageNum = e
      this.tableParams.pageNum = e
      this.init()
    },
    tableSummary(row) {
      const arr = ['showSmt', 'ecpm', 'clkSmt', 'income']
      const fixedArr = ['ecpm', "income", 'clickRate']
      const { data } = row
      let checklists = this.checkColumns.map(item => {
        return item.field
      })
      checklists.unshift("0")
      const out = []
      for (let i = 0; i < checklists.length; i++) {
        if (i === 0) {
          out[i] = '合计'
        } else {
          if (fixedArr.indexOf(checklists[i]) > -1) {
            if (checklists[i] == 'clickRate') {
              out[i] = ((data.reduce((total, item) => { return total + Number(item["clkSmt"]) }, 0)) / (data.reduce((total, item) => { return total + Number(item["showSmt"]) }, 0)) * 100).toFixed(2)
            } else {
              out[i] = (data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0)).toFixed(2)
            }
          } else {
            out[i] = arr.indexOf(checklists[i]) > -1 ? data.reduce((total, item) => { return total + Number(item[checklists[i]]) }, 0) : '-'
          }
        }
      }
      return out
    }
  }
}
</script>

<style scoped lang="scss">
.search-wrapper {
  padding: 15px 15px 5px;
  margin-bottom: 10px;
  background: #ffffff;

  &>* {
    margin-right: 15px;
    margin-bottom: 10px;

    &:last-child {
      margin-right: 0;
    }
  }

  &>.el-select,
  &>.el-input {
    width: 220px;
  }
}

.table-wrapper {
  padding: 15px;
  background: #ffffff;

  .table__operation {
    padding-bottom: 10px;
  }
}

.el-table::before {
  height: 0;
}

.el-pagination {
  text-align: right;
}
</style>
